import { Sanity$HeaderCentered } from '@otovo/shared/types/sanityTypes';
import cx from 'classnames';
import { stegaClean } from 'next-sanity';

type Props = {
  content: Sanity$HeaderCentered;
};

const HeaderCentered = ({ content }: Props) => {
  return (
    <div
      className={cx(
        content.stylingOptions &&
          stegaClean(content.stylingOptions.colorScheme),
        'bg-surface',
      )}
      data-testid="header-centered"
    >
      <div className="mx-auto max-w-8xl px-4 py-16 md:px-6 md:py-20 lg:px-16 lg:py-24 xl:py-32">
        <div className="flex justify-center">
          <div className="max-w-2xl space-y-3 text-center xl:max-w-3xl">
            <span className="block caption-m text-subheading">
              {content.tagline}
            </span>
            <h2 className="text-2xl font-semibold text-pretty text-heading md:text-3xl lg:text-4xl">
              {content.heading}
            </h2>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderCentered;
